import { Platform } from '@angular/cdk/platform';
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';
import {
    HTTP_HEADERS_DISABLED_USER_INTERACTION,
    HTTP_HEADERS_SHOW_PROGRESS,
    HTTP_HEADERS_SHOW_PROGRESS_VALUE,
} from '@constants/app.constant';
import { environment } from '@env/environment';
import { ProgressService } from '@services/progress.service';
import { ToastService } from '@services/toast.service';
import { generateTick } from '@utils/request.util';
import { catchError, finalize, throwError } from 'rxjs';

export const baseInterceptor: HttpInterceptorFn = (req, next) => {
    const localeId = inject(LOCALE_ID);
    const toastService = inject(ToastService);
    const progressService = inject(ProgressService);
    const isServer = !inject(Platform).isBrowser;
    const { apiUrl } = environment;

    req.headers.set('PN-Client-Language', localeId);
    const showProgressValue = req.headers.get(HTTP_HEADERS_SHOW_PROGRESS);
    const disabledUserClick = req.headers.get(HTTP_HEADERS_DISABLED_USER_INTERACTION);
    const isCallEnvApi = req.url.includes(apiUrl) && !isServer;
    const isShowLoading = isCallEnvApi && showProgressValue === HTTP_HEADERS_SHOW_PROGRESS_VALUE;
    const isDisabledUserClick =
        isCallEnvApi && disabledUserClick === HTTP_HEADERS_SHOW_PROGRESS_VALUE;

    if (isShowLoading) {
        progressService.start(undefined, isDisabledUserClick);
    }

    return next(
        req.clone({
            withCredentials: true,
            headers: req.headers
                .set('PN-Client-Language', localeId)
                .set('Pn-Client', generateTick()),
        })
    ).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                const statuses = [
                    HttpStatusCode.InternalServerError,
                    HttpStatusCode.ServiceUnavailable,
                    HttpStatusCode.NotFound,
                ];
                const networkConnectionError = !isServer && !error.status;

                if ((statuses.includes(error.status) || networkConnectionError) && isCallEnvApi) {
                    const message = $localize`:@@base.interceptor.unexpected-error:Đã xảy ra lỗi không mong muốn. Vui lòng thử lại sau ít phút hoặc liên hệ quản trị viên để được hổ trợ!`;
                    toastService.error(
                        $localize`:@@base.interceptor.error:Có lỗi xảy ra`,
                        message,
                        {
                            id: 'base-interceptor',
                        }
                    );
                }
            }
            return throwError(() => error);
        }),
        finalize(() => {
            // hide loading
            if (isShowLoading) {
                progressService.complete(undefined, isDisabledUserClick);
            }
        })
    );
};
